import React from "react";
import Header from "../basic/Header";
import './enroll.css';
import greenTickImage from '../../images/greenTick.png';
import RegisterForCourse from "./RegisterForCourse";
import MlPythonForm from "./MLPythonForm";

class Enroll extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        const { program, course } = this.props.location.state;
        return (
            <div>
                <Header title={"Enroll Now"} subTitleText={"Register now to master the course and add a new skill to your profile"}/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h4>{program} / {course.title}</h4>
                            <hr />
                            <h5><u>Course Details:</u></h5>
                            {this.loadCourseDetails(program, course)}
                            <hr />
                            <h5><u>Description:</u></h5>
                            {this.loadCourseDescription(course)}
                            <hr />
                            <h5><u>Benefits:</u></h5>
                            <div className={"benefits"}>
                                { this.loadBenefits(course) }
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h4>Enroll Now!</h4>
                            <hr />
                            {this.loadRegistrationForm(program, course)}
                        </div>
                    </div>
                    <hr style={{padding: "0px"}}/>
                </div>
            </div>
        );
    }

    loadBenefits(course) {
        return course.benefits.map((benefit, id) =>
            <div key={id}>
                <div className={"benefit"}>
                    <img className={"greenTick"} src={greenTickImage} alt={""}/>
                    <p className={"benefitDesc"}>{benefit.text}</p>
                </div>
                <br />
            </div>
        );
    }

    loadCourseDetails(program, course) {
        return <table>
            <tbody>
                <tr>
                    <td>Program Name: </td>
                    <td><strong>{program}</strong></td>
                </tr>
                <tr>
                    <td>Course Name: </td>
                    <td><strong>{course.title}</strong></td>
                </tr>
                <tr>
                    <td>Duration: </td>
                    <td><strong>{course.duration}</strong></td>
                </tr>
                <tr>
                    <td>Mode: </td>
                    <td><strong>{course.mode}</strong></td>
                </tr>
                {/*<tr>*/}
                {/*    <td>Price: </td>*/}
                {/*    <td><strong>{course.price}</strong></td>*/}
                {/*</tr>*/}
            </tbody>
        </table>
    }

    loadCourseDescription(course) {
        return <div className={"description"}>
                <p>{course.description.line1}</p>
                <p>{course.description.line2}</p>
            </div>
    }

    loadRegistrationDetails() {
        return <div>
            <address>
                <h5><strong>Engineering Guru</strong></h5>
            </address>
            <p>Registrations are not open yet, Please stay tuned for updates...</p>
            <p>Also, you can express your interest to enroll in this course by reaching out to us over the email </p>
            <address>
                <a href="mailto:team@engineeringguru.in">team@engineeringguru.in</a>
            </address>
            <p>We will get back to you with details on further process</p>
        </div>
    }

    loadRegistrationForm(program, course) {
        if(course.enrollmentUrl === '/Engineering_Courses/Machine_Learning_Fundamentals')
            return <MlPythonForm />;
        return <RegisterForCourse program={program} course={course.title} />
    }
}

Enroll.propTypes = {};

export default Enroll;
